import { IResourceComponentsProps, useOne, useShow } from '@pankod/refine-core';
import { Avatar, Card, Col, Row, Show, Space, Typography } from '@pankod/refine-antd';
import { IRole, IUser } from 'interfaces';
import { PageHeader } from 'components';
import defaultAvatar from 'assets/images/default-avatar.jpg';

const { Title, Text } = Typography;

export const UserShow: React.FC<IResourceComponentsProps> = () => {
  const { queryResult } = useShow<IUser>({
    metaData: {
      fields: [
        'id',
        'name',
        'email',
        'userCode',
        'mobileNumber',
        'role',
        {
          userPhoto: [
            {
              avatar: ['url', 'thumbUrl'],
            },
          ],
        },
      ],
    },
  });
  const { data, isFetching } = queryResult;
  const record = data?.data;
  const userPhoto = record?.userPhoto;
  let avatarURL;
  if (userPhoto instanceof Array) {
    avatarURL = userPhoto[userPhoto?.length - 1]?.avatar?.url;
  }

  const roleQueryResult = useOne<IRole>({
    resource: 'role',
    id: record?.role,
    metaData: {
      fields: ['name'],
    },
  });
  const roleName = roleQueryResult.data?.data.name;

  return (
    <Show isLoading={isFetching} headerProps={{ extra: <PageHeader path="/users" /> }}>
      <Row gutter={[48, 32]} wrap>
        <Col xs={24} lg={7}>
          <Card
            style={{
              backgroundColor: '#FAFAFA',
              opacity: 1,
            }}
            bodyStyle={{ height: '300px' }}
          >
            <Space
              direction="vertical"
              align="center"
              style={{
                width: '100%',
                textAlign: 'center',
                margin: '26px 0 30px 0',
              }}
            >
              <Avatar
                size={200}
                style={{ objectFit: 'cover' }}
                src={avatarURL || defaultAvatar}
                alt={`Avatar`}
              />
            </Space>
          </Card>
        </Col>
        <Col xs={24} lg={17}>
          <Title level={5}>Name</Title>
          <Text>{record?.name}</Text>
          <Title level={5}>Email</Title>
          <Text>{record?.email}</Text>
          <Title level={5}>Mobile Number</Title>
          <Text>{record?.mobileNumber}</Text>
          <Title level={5}>Supplier Code</Title>
          <Text>{record?.userCode}</Text>
          <Title level={5}>User Type</Title>
          <Text>{roleName}</Text>
        </Col>
      </Row>
    </Show>
  );
};
